import React from "react";
import { ShieldCheck, Award, Sparkles, Briefcase, CheckCircle2, Crown } from "lucide-react";

const BADGE_CONFIG = [
  { key: "verified_learner", label: "Verified Learner", icon: ShieldCheck },
  { key: "verified_certificate", label: "Verified Certificate", icon: Award },
  { key: "verified_skills", label: "Verified Skills", icon: Sparkles },
  { key: "verified_projects", label: "Verified Projects", icon: Briefcase },
  { key: "verified_challenge_completion", label: "Verified Challenge Completion", icon: CheckCircle2 },
];

export default function VerifiedBadgesRow({ badges, openToWork, isPremium }) {
  const earned = BADGE_CONFIG.filter((b) => badges?.[b.key]);
  if (earned.length === 0 && !openToWork && !isPremium) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 justify-center" data-testid="portfolio-verified-badges-row">
      {isPremium && (
        <span className="flex items-center gap-1.5 text-xs font-bold bg-amber-400/10 border border-amber-400/30 text-amber-300 rounded-full px-3 py-1.5" data-testid="portfolio-premium-badge">
          <Crown className="w-3.5 h-3.5" /> Premium Member
        </span>
      )}
      {openToWork && (
        <span className="flex items-center gap-1.5 text-xs font-bold bg-emerald-400/10 border border-emerald-400/30 text-emerald-400 rounded-full px-3 py-1.5" data-testid="portfolio-open-to-work-badge">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" /> Open to Work
        </span>
      )}
      {earned.map((b) => (
        <span key={b.key} className="flex items-center gap-1.5 text-xs font-semibold bg-indigo-400/10 border border-indigo-400/30 text-indigo-300 rounded-full px-3 py-1.5" data-testid={`portfolio-badge-${b.key}`}>
          <b.icon className="w-3.5 h-3.5" /> {b.label}
        </span>
      ))}
    </div>
  );
}
